module.exports = __webpack_public_path__ + "img/PAS_RESERVE_GRILLE_POINTAGE.95a38685.svg";